const APP_MODE_QUERY_PARAM = 'app';

export const isInAppMode = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return (
    searchParams.has(APP_MODE_QUERY_PARAM) && searchParams.get(APP_MODE_QUERY_PARAM) === 'true'
  );
};

let hasClosedBrowser = false;
export const closeAppBrowser = (eventId: string) => {
  if (hasClosedBrowser) return;
  hasClosedBrowser = true;
  window.location.href = `evite://app/event/${eventId}/send`;
};

export const redirectAfterDowngrade = (eventId: string) => {
  window.location.href = `evite://app/event/${eventId}/downgrade`;
};

export const generateAppHeaders = (): Record<string, string> => {
  const searchParams = new URLSearchParams(window.location.search);
  const appSessionId = searchParams.get('app-session-id');
  const appInstanceId = searchParams.get('app-instance-id');
  const appPlatform = searchParams.get('app-platform');
  const headers: Record<string, string> = {};
  if (appSessionId) {
    headers['app-session-id'] = appSessionId;
  }
  if (appInstanceId) {
    headers['app-instance-id'] = appInstanceId;
  }
  if (appPlatform) {
    headers['app-platform'] = appPlatform;
  }
  return headers;
};
